import {CommentsCategory} from '@domain/comments'
import {PermissionType} from '@hconnect/apiclient/src/types'
import {useUpmPlantContext} from '@hconnect/upm'
import {
  checkPermissionAccessByDataScope,
  usePermissionsParsedQuery,
  type DataScope
} from '@hproduce/permissions'
import {useMemo} from 'react'

type PlannerDataScope = DataScope & {
  commentCategory?: CommentsCategory
}

enum CommentPermissionTypes {
  ViewComments = 'VIEW_COMMENTS',
  AddComments = 'ADD_COMMENTS',
  EditComments = 'EDIT_COMMENTS',
  DeleteComments = 'DELETE_COMMENTS'
}

/**
 * @deprecated
 */
export const useCommentsPermissions = (category: CommentsCategory) => {
  const {data: permissions} = usePermissionsParsedQuery()
  const {country: countryId} = useUpmPlantContext()
  const {plantId: plantCode} = useUpmPlantContext()

  return useMemo(() => {
    const commentsPermissions = (permissions || []).filter(({permissionType, parsedDataScope}) => {
      const commentPermissionDataScope = parsedDataScope as Partial<PlannerDataScope>
      return (
        (
          [
            CommentPermissionTypes.ViewComments,
            CommentPermissionTypes.AddComments,
            CommentPermissionTypes.EditComments,
            CommentPermissionTypes.DeleteComments
          ] as PermissionType[]
        ).includes(permissionType) &&
        commentPermissionDataScope.commentCategory === category &&
        checkPermissionAccessByDataScope(countryId, plantCode, commentPermissionDataScope)
      )
    })

    const commentsPermissionTypes = commentsPermissions.map(
      (permission) => permission.permissionType
    )

    const canViewComments = commentsPermissionTypes.includes(CommentPermissionTypes.ViewComments)
    const canAddComments = commentsPermissionTypes.includes(CommentPermissionTypes.AddComments)
    const canEditComments = commentsPermissionTypes.includes(CommentPermissionTypes.EditComments)
    const canDeleteComments = commentsPermissionTypes.includes(
      CommentPermissionTypes.DeleteComments
    )
    return {canViewComments, canAddComments, canEditComments, canDeleteComments}
  }, [permissions, category, plantCode, countryId])
}
